import { ReactNode } from "react";
import { GripVertical } from "lucide-react";

import { useOrdenavel } from "../hooks/useOrdenavel";

interface ListaOrdenavelProps<T extends { id: string }> {
  itens: T[];
  onMover: (ids: string[]) => void;
  onSalvar: (ids: string[]) => Promise<void>;
  children: (item: T) => ReactNode;
  className?: string;
}

export function ListaOrdenavel<T extends { id: string }>({
  itens,
  onMover,
  onSalvar,
  children,
  className = "space-y-4",
}: ListaOrdenavelProps<T>) {
  const { arrastando, propsDaLinha } = useOrdenavel(
    itens.map((i) => i.id),
    onMover,
    onSalvar
  );

  return (
    <div className={className}>
      {itens.map((item) => (
        <div
          key={item.id}
          {...propsDaLinha(item.id)}
          className={`flex items-stretch gap-2 transition-opacity ${arrastando === item.id ? "opacity-40" : ""}`}
        >
          <div
            className="flex items-center cursor-grab active:cursor-grabbing text-muted-foreground"
            title="Arraste para reordenar"
          >
            <GripVertical className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">{children(item)}</div>
        </div>
      ))}
    </div>
  );
}
